(() => {
  if (customElements.get('scroll-lettering')) return;
  const nativeTimeline = CSS.supports('animation-timeline: --section-lettering');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  const visible = new Set();
  const registered = new Set();
  let frame = 0;
  let listening = false;
  const paint = () => {
    frame = 0;
    if (reduce.matches || document.hidden) return;
    const writes = [];
    for (const el of visible) {
      if (!el.isConnected || (mobile.matches && el.dataset.mobile === 'false')) continue;
      const box = el.parentElement.getBoundingClientRect();
      const progress = Math.min(1, Math.max(0, (innerHeight - box.top) / (innerHeight + box.height)));
      const distance = Number(mobile.matches ? el.dataset.distanceMobile : el.dataset.distance);
      const x = (progress * 2 - 1) * distance * Number(el.dataset.direction);
      writes.push([el.text, `translate3d(${x.toFixed(2)}px, ${(8 - progress * 16).toFixed(2)}%, 0)`]);
    }
    for (const [text, transform] of writes) text.style.transform = transform;
  };
  const schedule = () => {
    if (!frame && !reduce.matches && !document.hidden) frame = requestAnimationFrame(paint);
  };
  const observer = !nativeTimeline && 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    }
    schedule();
  }, {rootMargin: '100px'}) : null;
  const sync = () => {
    const needed = registered.size > 0 && !reduce.matches;
    if (needed !== listening) {
      const method = needed ? 'addEventListener' : 'removeEventListener';
      window[method]('scroll', schedule, {passive:true});
      window[method]('resize', schedule);
      document[method]('visibilitychange', schedule);
      listening = needed;
    }
    if (!needed) {
      cancelAnimationFrame(frame);
      frame = 0;
      for (const el of registered) el.text.style.removeProperty('transform');
    } else schedule();
  };
  if (!nativeTimeline) {
    reduce.addEventListener('change', sync);
    mobile.addEventListener('change', schedule);
  }
  customElements.define('scroll-lettering', class extends HTMLElement {
    connectedCallback() {
      if (nativeTimeline || this.dataset.motion !== 'true') return;
      this.text = this.querySelector('.section-lettering__text');
      if (!this.text) return;
      registered.add(this);
      if (observer) observer.observe(this);
      else visible.add(this);
      sync();
    }
    disconnectedCallback() {
      observer?.unobserve(this);
      registered.delete(this);
      visible.delete(this);
      sync();
    }
  });
})();
